import RequireAuth from '@Components/Utility/RequireAuth'
import RightsholderLayout from '@Scenes/RightsholderScene/RightsholderLayout'
import React from 'react'
import './index.scss'
import createCreateWorkRoutes from '@App/routes/rightsholder/creatework'
import createRightsholderRootRoutes from '@App/routes/rightsholder/root'

import { RIGHTSHOLDER_ROUTE_WITH_ID } from '@App/navigation/route'

const createRightsholderRoutes = () => {
    const createWorkRoutes = createCreateWorkRoutes()
    const rightsholderRootRoutes = createRightsholderRootRoutes()

    return {
        path: RIGHTSHOLDER_ROUTE_WITH_ID,
        element: (
            <RequireAuth>
                <RightsholderLayout />
            </RequireAuth>
        ),
        children: [createWorkRoutes, rightsholderRootRoutes],
    }
}

export default createRightsholderRoutes
